import BarChart from "./BarChart";
import LineChart from "./LineChart";

const charts = {BarChart, LineChart};

export default charts;
